export default "__VITE_ASSET__CIZIMOt1__"